import { Component, inject, OnInit } from '@angular/core'
import { DataCardService } from '../../../../../services/data-card.service'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { HttpErrorResponse } from '@angular/common/http'
import { IDataCardNotification } from '../../../../../models/data-card.model'
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal"

@Component({
    selector: 'app-notifications-modal',
    templateUrl: './notifications-modal.component.html',
    standalone: false
})
export class NotificationsModalComponent implements OnInit {
  public readonly nzModalData: {mainObject: string} = inject(NZ_MODAL_DATA);

  private _notifications: IDataCardNotification[] = []
  private _isLoading: boolean = false

  public get notifications(): IDataCardNotification[] {
    return this._notifications
  }

  public get isLoading(): boolean {
    return this._isLoading
  }

  public constructor(
    private dataCardService: DataCardService,
    private responseHandlerService: HttpResponseHandlerService,
    private modal: NzModalRef
  ) {}

  private getNotifications(): void {
    this._isLoading = true
    this.dataCardService.getNotificationsByMainObject(this.nzModalData.mainObject).subscribe({
      next: (response: any) => {
        this._notifications = response
        this._isLoading = false
      },
      error: (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    })
  }

  public cancel(): void {
    this.modal.destroy()
    // this.modal.destroy({data: 'Some Data'}) // Send data back
  }

  public ngOnInit(): void {
    this.getNotifications()
  }
}
